import LayoutMaster from "components/layout/layout_master";
import CountUp from "react-countup";
import { useEffect, useState } from "react";
import jackpot_amount from "lib/worker/api/jackpot_amount";
import { AppReducerStateProps } from "lib/store";
import { connect } from "react-redux";
import { pusher } from "components/PusherEvent";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { query } = context;
  const { req } = context;

  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      prefix: query.prefix,
      infomation: infomation,
    },
  };
};

interface JackpotDepositProps {
  prefix: string;
  infomation: CheckWithPrefixResponse;
}

function JackpotDeposit(_props: JackpotDepositProps) {
  const [jackpotAmountAfter, setJackpotAmountAfter] = useState<number>(0);
  const [jackpotAmountBefore, setJackpotAmountBefore] = useState<number>(0);
  var beforeAmount = 0.0;

  useEffect(() => {
    jackpot_amount({ prefix: _props.prefix }).then((json) => {
      const total = json;
      setJackpotAmountBefore(json);
      setJackpotAmountAfter(beforeAmount);
      setJackpotAmountBefore(total);
      beforeAmount = total;
    });
  }, []);

  useEffect(() => {
    const channelJackpot = pusher.subscribe(
      "private-client-my-channel-reload-jackpot"
    );

    channelJackpot.bind(`reload`, () => {
      jackpot_amount({ prefix: _props.prefix }).then((json) => {
        const total = json;
        setJackpotAmountAfter(beforeAmount);
        setJackpotAmountBefore(total);
        beforeAmount = total;
      });
    });

    return () => {
      channelJackpot.unbind_all();
      channelJackpot.disconnect();
    };
  }, []);

  return (
    <LayoutMaster
      content_setting={{
        title: "แจ็คพอต ทุกยอดฝากเงินมีโอกาสได้รับรางวัล",
        description: "ลุ้นรับแจ็คพอตแตก มากมาย จากการฝากเงิน",
      }}
      information={_props.infomation}
    >
      <div className="container" style={{ paddingTop: 10 }}>
        <h1 style={{ fontSize: 30 }}>
          <span>แจ็คพอตลุ้นรับรางวัลใหญ่</span>
        </h1>
        <h2 style={{ fontSize: 16 }}>
          <span>ทางเราใจดีสุ่มมอบรางวัลพิเศษให้กับลูกค้าที่ทำการฝากเงิน</span>
        </h2>

        <div className="container mb-margin-bottom-20 select-div">
          <div className="row center-row-content">
            <div
              style={{
                marginTop: 20,
                height: 60,
                width: 280,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundImage: `url(${"https://aelwrzoecp.cloudimg.io/v7/_sevenduckciio_/normal/jackpot_blink.gif?w=300"})`,
              }}
            >
              <div
                style={{ height: "100%" }}
                className="row center-row-content text-center"
              >
                <CountUp
                  className="font-jackpot-ufa"
                  start={jackpotAmountAfter}
                  end={jackpotAmountBefore}
                  decimals={2}
                  suffix=" บาท"
                  separator=","
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <h4 style={{ paddingTop: 30, fontSize: 24 }}>
            <span> แจ็คพอต จะเพิ่มขึ้นทุกๆครั้งที่ทำการฝากเงิน</span>
          </h4>
          <h4 className="margin-left-10">การออกรางวัล</h4>
          <ul className="margin-left-10">
            <li>
              ทุกๆการฝากเงิน ระบบจะทำการบวกเงินแจ็คพอตที่ <span>0.001%</span>{" "}
              ของยอดฝากเงิน
            </li>
            <li>
              ทุกยอดการฝาก มีโอกาสได้รับรางวัล <span>0.000001%</span>
            </li>
            <li className="font-red">
              *นโยบายอาจเปลี่ยนแปลงไปตามที่บริษัทเป็นผู้กำหนด
              หากพยายามทุจริตหรือปลอมแปลงใดๆ จะมีกฏลงโทษแบนทันที
            </li>
          </ul>
        </div>
      </div>
    </LayoutMaster>
  );
}

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(JackpotDeposit);
